import styled from "styled-components";
import MarketPlaceItemCard from "../components/Marketplace/MarketPlaceItemCard";
import FilterOption from "../components/Marketplace/FilterOption";
import { useEffect } from "react";
import ZkMarketplace from "./MarketplaceZkEVM";

const StyledMarketPlace = styled.div`
    height: 75vh;
    width: 100vw;
    margin: 65px 0px 0px 0px;
    display: flex;
    flex-direction: row;
    justify-content: start;
    align-items: center;   
    
    html {
        overflow: scroll;
    }

    ::-webkit-scrollbar {
        width: 0px;
        background: transparent; /* make scrollbar transparent */
    }
    
    .filter-section-container {
        width: 320px;
        height: 100%;
        background: #1C1C1C;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: center;
        margin: 0px;
        overflow-y: scroll;
    }

    .content-section-container {
        height: 100%;        
        background: transparent;
        display: flex;
        flex-direction: column;
        justify-content: start;
        align-items: start;
        flex: 2;
    }

    #market-title-description {
        height: 80px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: start;  
        margin: 35px 25px 35px 25px;      
    }

    #market-title {
        font-size: 34px;
        font-weight: 700;
        line-height: 40px;
        color: #FFFFFF;
        margin: 0px;
    }

    #market-description {
        font-size: 20px;
        font-weight: 300;
        line-height: 44px;
        color: #A6A6A6;
        margin: 0px;
    }

    #assets-store-container {
        width: 100%;
        flex: 2;
        display: flex;
        justify-content: start;
        align-items: center;
        margin: 0px; 
        flex-wrap: wrap;
        overflow-y: scroll;   
        padding-bottom: 25px;     
    }

    .accordion-tile {
        padding-left: 24px;
        padding-right: 24px;
        width: 100%;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: center;

        p {
            font-weight: 500;
            font-size: 18px;
            line-height: 21px;
            color: #FFFFFF;
            margin: 0px;
        }        

        .accordion-header {
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: center; 
        }
    }

    .filter-selector {
        width: 246px;
        margin: 10px 20px 24px 20px;    
        height: 37px;
        border-radius: 20px;
        background: #FFFFFF0D;
        display: flex;
        justify-content: space-between;
        align-items: center; 
        padding-left: 16px;
        padding-right: 16px;
        border-width: 1px;
        border-color: #FFFFFF1A;
        border-style: solid;
        
        p {
            margin: 0px;
            font-size: 14px;
            font-weight: 400;
            line-height: 19px;
            color: #A6A6A6;
        }        
    }

    #filter-controls {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }

    .filter-option-radio {
        padding: 10px 20px 10px 20px;
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;        
    }

    .filter-option-text {
        margin: 0px;
        flex: 2;
    }

    #apply-filters-button{
        width: 246px;
        height: 47px;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 14px;
        background: linear-gradient(#38EF7D, #11998E);
        color: #FFFFFF;
    }

    #filter-controls {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding-left: 25px;
        padding-right: 25px;
        padding-top: 10px;

        #clear-all-button {
            color: #38EF7D;
            text-decoration: underline;
            font-size: 16px;
            font-weight: 400;
            line-height: 19.2px;
        }
    }
`;

export default function MarketPlace({items}){
    return (
        <StyledMarketPlace>
            <div className="filter-section-container">
                <div id="filter-controls">
                    <p>Filter</p>
                    <div id="clear-all-button">
                        Clear All
                    </div>
                </div>
                <div className="accordion-tile">
                    <div className="accordion-header">
                        <p>Sort item by</p>
                        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.78125 8.52344C6.58333 8.52344 6.40625 8.44792 6.25 8.29688L0.203125 2.10938C0.135417 2.04167 0.0833333 1.96615 0.046875 1.88281C0.0104167 1.79427 -0.0078125 1.70052 -0.0078125 1.60156C-0.0078125 1.46615 0.0234375 1.34375 0.0859375 1.23438C0.148438 1.125 0.231771 1.03906 0.335938 0.976562C0.445312 0.914062 0.567708 0.882812 0.703125 0.882812C0.901042 0.882812 1.07031 0.950521 1.21094 1.08594L7.19531 7.20312H6.35938L12.3438 1.08594C12.4896 0.950521 12.6589 0.882812 12.8516 0.882812C12.987 0.882812 13.1068 0.914062 13.2109 0.976562C13.3203 1.03906 13.4062 1.125 13.4688 1.23438C13.5312 1.34375 13.5625 1.46615 13.5625 1.60156C13.5625 1.79427 13.4922 1.96094 13.3516 2.10156L7.30469 8.29688C7.23698 8.36979 7.15625 8.42708 7.0625 8.46875C6.97396 8.50521 6.88021 8.52344 6.78125 8.52344Z" fill="white"/>
                        </svg>
                    </div>
                    <div className="filter-selector">
                        <p>Sort A-Z</p>
                        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.78125 8.52344C6.58333 8.52344 6.40625 8.44792 6.25 8.29688L0.203125 2.10938C0.135417 2.04167 0.0833333 1.96615 0.046875 1.88281C0.0104167 1.79427 -0.0078125 1.70052 -0.0078125 1.60156C-0.0078125 1.46615 0.0234375 1.34375 0.0859375 1.23438C0.148438 1.125 0.231771 1.03906 0.335938 0.976562C0.445312 0.914062 0.567708 0.882812 0.703125 0.882812C0.901042 0.882812 1.07031 0.950521 1.21094 1.08594L7.19531 7.20312H6.35938L12.3438 1.08594C12.4896 0.950521 12.6589 0.882812 12.8516 0.882812C12.987 0.882812 13.1068 0.914062 13.2109 0.976562C13.3203 1.03906 13.4062 1.125 13.4688 1.23438C13.5312 1.34375 13.5625 1.46615 13.5625 1.60156C13.5625 1.79427 13.4922 1.96094 13.3516 2.10156L7.30469 8.29688C7.23698 8.36979 7.15625 8.42708 7.0625 8.46875C6.97396 8.50521 6.88021 8.52344 6.78125 8.52344Z" fill="white"/>
                        </svg>
                    </div>
                </div>                
                <div className="accordion-tile">
                    <div className="accordion-header">
                        <p>Multiplier</p>
                        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.78125 8.52344C6.58333 8.52344 6.40625 8.44792 6.25 8.29688L0.203125 2.10938C0.135417 2.04167 0.0833333 1.96615 0.046875 1.88281C0.0104167 1.79427 -0.0078125 1.70052 -0.0078125 1.60156C-0.0078125 1.46615 0.0234375 1.34375 0.0859375 1.23438C0.148438 1.125 0.231771 1.03906 0.335938 0.976562C0.445312 0.914062 0.567708 0.882812 0.703125 0.882812C0.901042 0.882812 1.07031 0.950521 1.21094 1.08594L7.19531 7.20312H6.35938L12.3438 1.08594C12.4896 0.950521 12.6589 0.882812 12.8516 0.882812C12.987 0.882812 13.1068 0.914062 13.2109 0.976562C13.3203 1.03906 13.4062 1.125 13.4688 1.23438C13.5312 1.34375 13.5625 1.46615 13.5625 1.60156C13.5625 1.79427 13.4922 1.96094 13.3516 2.10156L7.30469 8.29688C7.23698 8.36979 7.15625 8.42708 7.0625 8.46875C6.97396 8.50521 6.88021 8.52344 6.78125 8.52344Z" fill="white"/>
                        </svg>
                    </div>
                    <div className="filter-selector">
                        <p>Multiplier x4</p>
                        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.78125 8.52344C6.58333 8.52344 6.40625 8.44792 6.25 8.29688L0.203125 2.10938C0.135417 2.04167 0.0833333 1.96615 0.046875 1.88281C0.0104167 1.79427 -0.0078125 1.70052 -0.0078125 1.60156C-0.0078125 1.46615 0.0234375 1.34375 0.0859375 1.23438C0.148438 1.125 0.231771 1.03906 0.335938 0.976562C0.445312 0.914062 0.567708 0.882812 0.703125 0.882812C0.901042 0.882812 1.07031 0.950521 1.21094 1.08594L7.19531 7.20312H6.35938L12.3438 1.08594C12.4896 0.950521 12.6589 0.882812 12.8516 0.882812C12.987 0.882812 13.1068 0.914062 13.2109 0.976562C13.3203 1.03906 13.4062 1.125 13.4688 1.23438C13.5312 1.34375 13.5625 1.46615 13.5625 1.60156C13.5625 1.79427 13.4922 1.96094 13.3516 2.10156L7.30469 8.29688C7.23698 8.36979 7.15625 8.42708 7.0625 8.46875C6.97396 8.50521 6.88021 8.52344 6.78125 8.52344Z" fill="white"/>
                        </svg>
                    </div>
                </div>
                <div className="accordion-tile">
                    <div className="accordion-header">
                        <p>Price</p>
                        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.78125 8.52344C6.58333 8.52344 6.40625 8.44792 6.25 8.29688L0.203125 2.10938C0.135417 2.04167 0.0833333 1.96615 0.046875 1.88281C0.0104167 1.79427 -0.0078125 1.70052 -0.0078125 1.60156C-0.0078125 1.46615 0.0234375 1.34375 0.0859375 1.23438C0.148438 1.125 0.231771 1.03906 0.335938 0.976562C0.445312 0.914062 0.567708 0.882812 0.703125 0.882812C0.901042 0.882812 1.07031 0.950521 1.21094 1.08594L7.19531 7.20312H6.35938L12.3438 1.08594C12.4896 0.950521 12.6589 0.882812 12.8516 0.882812C12.987 0.882812 13.1068 0.914062 13.2109 0.976562C13.3203 1.03906 13.4062 1.125 13.4688 1.23438C13.5312 1.34375 13.5625 1.46615 13.5625 1.60156C13.5625 1.79427 13.4922 1.96094 13.3516 2.10156L7.30469 8.29688C7.23698 8.36979 7.15625 8.42708 7.0625 8.46875C6.97396 8.50521 6.88021 8.52344 6.78125 8.52344Z" fill="white"/>
                        </svg>
                    </div>
                    <div className="filter-option-radio">
                        <FilterOption optionText={'Price'} isSelected={true}></FilterOption>
                    </div>                    
                    <div className="filter-option-radio">
                        <FilterOption optionText={'Date Listed'} isSelected={false}></FilterOption>
                    </div>                    
                </div>
                <div className="accordion-tile">
                    <div className="accordion-header">
                        <p>Categories</p>
                        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.78125 8.52344C6.58333 8.52344 6.40625 8.44792 6.25 8.29688L0.203125 2.10938C0.135417 2.04167 0.0833333 1.96615 0.046875 1.88281C0.0104167 1.79427 -0.0078125 1.70052 -0.0078125 1.60156C-0.0078125 1.46615 0.0234375 1.34375 0.0859375 1.23438C0.148438 1.125 0.231771 1.03906 0.335938 0.976562C0.445312 0.914062 0.567708 0.882812 0.703125 0.882812C0.901042 0.882812 1.07031 0.950521 1.21094 1.08594L7.19531 7.20312H6.35938L12.3438 1.08594C12.4896 0.950521 12.6589 0.882812 12.8516 0.882812C12.987 0.882812 13.1068 0.914062 13.2109 0.976562C13.3203 1.03906 13.4062 1.125 13.4688 1.23438C13.5312 1.34375 13.5625 1.46615 13.5625 1.60156C13.5625 1.79427 13.4922 1.96094 13.3516 2.10156L7.30469 8.29688C7.23698 8.36979 7.15625 8.42708 7.0625 8.46875C6.97396 8.50521 6.88021 8.52344 6.78125 8.52344Z" fill="white"/>
                        </svg>
                    </div>
                    <div className="filter-option-radio">
                        <FilterOption optionText={'Qorbs'} isSelected={false}></FilterOption>
                    </div>  
                    <div className="filter-option-radio">
                        <FilterOption optionText={'QorX Pass'} isSelected={true}></FilterOption>
                    </div>  
                    <div className="filter-option-radio">
                        <FilterOption optionText={'Skins'} isSelected={false}></FilterOption>
                    </div>  
                    <div className="filter-option-radio">
                        <FilterOption optionText={'LoopBox'} isSelected={false}></FilterOption>
                    </div>  
                    <div className="filter-option-radio">
                        <FilterOption optionText={'Pets'} isSelected={false}></FilterOption>
                    </div>  
                </div>
                <div className="accordion-tile">
                    <div className="accordion-header">
                        <p>Weapons</p>
                        <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M6.78125 8.52344C6.58333 8.52344 6.40625 8.44792 6.25 8.29688L0.203125 2.10938C0.135417 2.04167 0.0833333 1.96615 0.046875 1.88281C0.0104167 1.79427 -0.0078125 1.70052 -0.0078125 1.60156C-0.0078125 1.46615 0.0234375 1.34375 0.0859375 1.23438C0.148438 1.125 0.231771 1.03906 0.335938 0.976562C0.445312 0.914062 0.567708 0.882812 0.703125 0.882812C0.901042 0.882812 1.07031 0.950521 1.21094 1.08594L7.19531 7.20312H6.35938L12.3438 1.08594C12.4896 0.950521 12.6589 0.882812 12.8516 0.882812C12.987 0.882812 13.1068 0.914062 13.2109 0.976562C13.3203 1.03906 13.4062 1.125 13.4688 1.23438C13.5312 1.34375 13.5625 1.46615 13.5625 1.60156C13.5625 1.79427 13.4922 1.96094 13.3516 2.10156L7.30469 8.29688C7.23698 8.36979 7.15625 8.42708 7.0625 8.46875C6.97396 8.50521 6.88021 8.52344 6.78125 8.52344Z" fill="white"/>
                        </svg>
                    </div>
                    <div className="filter-option-radio">
                        <FilterOption optionText={'Weapon #1'} isSelected={false}></FilterOption>
                    </div>  
                    <div className="filter-option-radio">
                        <FilterOption optionText={'Weapon #2'} isSelected={false}></FilterOption>
                    </div>  
                    <div className="filter-option-radio">
                        <FilterOption optionText={'Weapon #3'} isSelected={false}></FilterOption>
                    </div>  
                </div>
                <div id="apply-filters-button">
                    Apply Filters
                </div>
                {/* <div className="accordion-tile">
                    <p>Rarity</p>
                    <svg width="14" height="9" viewBox="0 0 14 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M6.78125 8.52344C6.58333 8.52344 6.40625 8.44792 6.25 8.29688L0.203125 2.10938C0.135417 2.04167 0.0833333 1.96615 0.046875 1.88281C0.0104167 1.79427 -0.0078125 1.70052 -0.0078125 1.60156C-0.0078125 1.46615 0.0234375 1.34375 0.0859375 1.23438C0.148438 1.125 0.231771 1.03906 0.335938 0.976562C0.445312 0.914062 0.567708 0.882812 0.703125 0.882812C0.901042 0.882812 1.07031 0.950521 1.21094 1.08594L7.19531 7.20312H6.35938L12.3438 1.08594C12.4896 0.950521 12.6589 0.882812 12.8516 0.882812C12.987 0.882812 13.1068 0.914062 13.2109 0.976562C13.3203 1.03906 13.4062 1.125 13.4688 1.23438C13.5312 1.34375 13.5625 1.46615 13.5625 1.60156C13.5625 1.79427 13.4922 1.96094 13.3516 2.10156L7.30469 8.29688C7.23698 8.36979 7.15625 8.42708 7.0625 8.46875C6.97396 8.50521 6.88021 8.52344 6.78125 8.52344Z" fill="white"/>
                    </svg>
                </div> */}
            </div>
            <div className="content-section-container">
                <div id="market-title-description">
                    <p id="market-title">My Collection</p>
                    <p id="market-description">Welcome to the One Tap Weapon Skin Color Series, a rare weapons skin collection with 400 variations of styles inspired by the first 5 maps in the game.</p>
                </div>
                <div id="assets-store-container">
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                    <MarketPlaceItemCard></MarketPlaceItemCard>
                </div>
            </div>
        </StyledMarketPlace>
    );
}